import React, { useMemo } from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

interface IWrapableTextProps extends IBaseProps {
  text: string;
  placeholder?: string;
}

const WrapableText: React.FC<IWrapableTextProps> = (props) => {
  const { style, className, text: textProps, placeholder = '-' } = props;

  const text = useMemo<string>(() => {
    if (typeof textProps !== 'string') return '';
    return textProps?.replace(/\n|\\n|\/n|\/\/n/g, '<br />');
  }, [textProps]);

  return (
    <div
      style={style}
      className={classnames('', className)}
      dangerouslySetInnerHTML={{ __html: text || placeholder }}
    ></div>
  );
};

export default React.memo(WrapableText);
